"use strict";

exports.__esModule = true;
exports.AggregateMeasureChartFields = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _DataRangeSelector = require("../../EditorFields/DataRangeSelector");
var _ColorPickerFormGroup = require("../../Form/ColorPicker/ColorPickerFormGroup");
var _XAxisFields = require("../../Recharts/Fields/XAxisFields");
var _HideXAxisFieldSelector = require("../MeasureChart/Fields/HideXAxisFieldSelector");
var _HideXAxisLabelFieldSelector = require("../MeasureChart/Fields/HideXAxisLabelFieldSelector");
var _YAxisFields = require("../MeasureChart/Fields/YAxisFields");
var _helper = require("../MeasureChart/helper");
var _TimeAggregationSelection = require("./TimeAggregationSelection");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var TooltipWrapper = _styledComponents["default"].div.withConfig({
  displayName: "AggregateMeasureChartFields__TooltipWrapper",
  componentId: "sc-ph0l6v-0"
})(["margin-bottom:10px;"]);
var AggregateMeasureChartFields = exports.AggregateMeasureChartFields = function AggregateMeasureChartFields(props) {
  var element = props.element,
    elementEditor = props.elementEditor,
    path = props.path;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_XAxisFields.XAxisFields, null, /*#__PURE__*/_react["default"].createElement(_TimeAggregationSelection.TimeAggregationSelection, props), /*#__PURE__*/_react["default"].createElement(_helper.FlexRow, null, /*#__PURE__*/_react["default"].createElement(_HideXAxisFieldSelector.HideXAxisFieldSelector, props), /*#__PURE__*/_react["default"].createElement(_HideXAxisLabelFieldSelector.HideXAxisLabelFieldSelector, props))), /*#__PURE__*/_react["default"].createElement(_YAxisFields.YAxisFields, _extends({}, props, {
    selectedColor: element.props.color
  })), /*#__PURE__*/_react["default"].createElement(_ColorPickerFormGroup.ColorPickerFormGroup, {
    color: element.props.color,
    setColor: function setColor(selectedColor) {
      return elementEditor.setProp(path, "color", selectedColor);
    }
  }), /*#__PURE__*/_react["default"].createElement(TooltipWrapper, null, /*#__PURE__*/_react["default"].createElement(_helper.AxisControls, null, /*#__PURE__*/_react["default"].createElement(_helper.CheckboxEl, _extends({
    propName: "hideTooltip",
    defaultLabel: "Hide Tooltip"
  }, props)))), /*#__PURE__*/_react["default"].createElement(_DataRangeSelector.DataRangeSelector, props));
};